/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { GET_CITIES } from '../../api/graphql';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IGetCitiesMethods extends IPluginMethodMap {
  getCities(args: any): Promise<any>;
}

export class GetCitiesService implements IAgentPlugin {
  readonly methods: IGetCitiesMethods;

  constructor() {
    this.methods = {
      getCities: this.getCities.bind(this),
    };
  }

  async getCities(args: any) {
    console.log(`args in user lists service`, args);
    const storageService = StorageModule.getInstance();

    const localToken = storageService.get('myProfile', 'local');
    const sessionToken = storageService.get('myProfile', 'session');
    const vuid = localToken?.vuid ?? sessionToken?.vuid;
    console.log('po->', vuid);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_CITIES, {
          parish: args,
        });
        if (res?.data?.getListOfCities?.length > 0) {
          console.log(`table data222`, res);

          return {
            cities: this._getCityOptions(res?.data?.getListOfCities),
          };
        } else {
          return {
            cities: [],
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getCityOptions = (data: any[]) => {
    let _options: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: string, index: number) => {
        if (item) {
          _options.push({
            label: item,
            id: item,
          });
        }
      });

    return _options;
  };

  private getAppCardList(data: any) {
    let appCardList: any = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        appCardList.push({
          appCardId: item?.applicationNo,
          appCardTitle: item?.employerInfo?.name,
          appCardDescription: item?.jobInfo?.JobTitle,
        });
      });
    return appCardList;
  }
}
